import React, { Fragment, PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from './takeActionForm.messages';
import { Form } from '../form.component';
import { accessibleClickHandler } from '../../../../utils/accessibility';
import FormModifier from './alterStructure';
import { FormCallbacks } from '../formUtils';

export class TakeActionForm extends PureComponent {
  static propTypes = {
    host: PropTypes.object.isRequired,
    hostWindow: PropTypes.object.isRequired,
    onFormRendered: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    stepBack: PropTypes.func.isRequired,
    activistCodeArray: PropTypes.array.isRequired,
  };

  state = {
    showButton: false,
  };

  componentDidMount() {
    this.initFormCallbacks();
  }

  showBackButton = ({ thank }) => {
    if (!thank) {
      setTimeout(() => this.setState({ showButton: true }));
    }
  };

  hideBackButton = () => this.setState({ showButton: false });

  initFormCallbacks() {
    const formModifier = new FormModifier(this.props.host, this.props.activistCodeArray);
    const callbacks = new FormCallbacks(this.props.hostWindow);

    callbacks.add('onSubmit', this.hideBackButton);
    callbacks.add('preSegue', this.props.onSubmit);
    callbacks.add('postFill', this.props.onFormRendered);
    callbacks.add('postRender', formModifier.populate);
    callbacks.add('postRender', this.showBackButton);
  }

  backButtonRef = createRef();

  render = () => (
    <Fragment>
      <Form {...this.props} />
      <div
        className="take-action-from__back-button"
        {...accessibleClickHandler(this.props.stepBack)}
        ref={this.backButtonRef}
        style={{ opacity: this.state.showButton ? 1 : 0 }}
      >
        <FormattedMessage {...messages.backButton} />
      </div>
    </Fragment>
  );
}
